import script from "./ProductInactive.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductInactive.vue?vue&type=script&setup=true&lang=ts"

import "./ProductInactive.vue?vue&type=style&index=0&id=0af5e296&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0af5e296"]])

export default __exports__